import { memo, type MouseEvent } from 'react';

import type { AppNavBrand } from './appNavTypes';

import { useLinkElement } from '../../../context/LinkNavigation/LinkNavigation';
import { isPlainLeftClick } from '../../../utils/isPlainLeftClick';

interface AppNavBrandLinkProps {
  brand: AppNavBrand;
  className: string;
}

/**
 * The brand link shared by the top bar and the drawer header: a real link home
 * that reports plain clicks to the host for its side effects.
 */
export const AppNavBrandLink = memo(function AppNavBrandLink({
  brand,
  className,
}: AppNavBrandLinkProps) {
  const BrandLink = useLinkElement(brand.href);

  return (
    <BrandLink
      aria-label={brand.label}
      className={className}
      href={brand.href}
      {...brand.dataAttributes}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        if (isPlainLeftClick(event)) {
          brand.onActivate?.();
        }
      }}
    >
      {brand.logo}
    </BrandLink>
  );
});
